import React, { useEffect, useState } from 'react';
import { FaApple } from 'react-icons/fa';

export const AppleLogin = () => {
  const [appleAuthUrl, setAppleAuthUrl] = useState(null);

  useEffect(() => {
    const clientId = process.env.REACT_APP_APPLE_CLIENT_ID;
    const redirectURI = process.env.REACT_APP_APPLE_REDIRECT_URI;
    
    if (!clientId || !redirectURI) {
     console.error("Apple Client ID or Redirect URI not set");
      return;
    }
    
    const state = Math.random().toString(36).substring(2, 15);
    localStorage.setItem('apple_state', state);

    const params = new URLSearchParams({
      response_type: 'code',
      response_mode: 'query',
      // response_mode: 'form_post',
      client_id: clientId,
      redirect_uri: redirectURI
      // state: state,
      // scope: 'name email',
    });

    setAppleAuthUrl(`https://appleid.apple.com/auth/authorize?${params}`);
  }, []);

  return appleAuthUrl ? (
    <a
      href={appleAuthUrl}
      className="flex items-center justify-center gap-4 w-full text-center text-white text-base md:text-xl font-medium border p-5 rounded-lg mt-4 bg-black hover:bg-gray-900"
    >
      <FaApple size={20} />
      Continue with Apple
    </a>
  ) : (
    <button
      disabled
      className="flex items-center justify-center gap-4 w-full text-center text-white text-base md:text-xl font-medium border p-5 rounded-lg mt-4 bg-gray-700 cursor-not-allowed"
    >
      <FaApple size={20} />
      Loading Apple Sign In...
    </button>
  );
};